
<div class="dialog-component">
  <div class="cross">
    <button
      id="desktop-focus"
      tabindex="0"
      type="button"
      class="close close-btn"
      aria-label="Close"
      (click) ="dialogData.clearErrors()"
    ></button>
  </div>

  <div class="image-container">
    <div class="profile-photo-header">
      <button
        id="mob-focus"
        tabindex="0"
        type="button"
        class="close close-btn"
        aria-label="Close"
        (click) ="dialogData.clearErrors()"
      ></button>
    </div>


    <div [formGroup]="dialogData.childForm" class="editChildBody">
      @if (dialogData.childError) {
        <div role="alert" aria-label="error" class="page-error">
          <label>Please fill correct details</label>
        </div>
      }
      <div>
        <div class="form-names">
          <label>First name</label>
          <input sanitizeInputForm aria-label="first name" (input)="dialogData.onInput($event)" formControlName="firstName" type="text">
        </div>
        <div class="form-names">
          <label>Last name</label>
          <input sanitizeInputForm aria-label="last name" (input)="dialogData.onInput($event)" formControlName="lastName" type="text">
        </div>
        <label class="dob-label" >
          Date of birth
        </label>
        <div class="dob-input">
              <ng-container [ngTemplateOutlet]="dateofbirth" [ngTemplateOutletContext]="{ $implicit:'day',
               control: dialogData.childForm.get('day'), displayType: 'dd', data: dialogData.days }">
          </ng-container>
             <ng-container [ngTemplateOutlet]="dateofbirth" [ngTemplateOutletContext]="{ $implicit:'month',
               control: dialogData.childForm.get('month'), displayType: 'month', data: dialogData.months }">
          </ng-container>
              <ng-container [ngTemplateOutlet]="dateofbirth" [ngTemplateOutletContext]="{ $implicit:'year',
              control: dialogData.childForm.get('year'), displayType: 'yyyy', data: dialogData.years }">
          </ng-container>
        </div>
        <div class="btn-container">
          <button tabindex="0" role="button" aria-label="add individual" class="child-button" [disabled]=""
          (click)="dialogData.saveChild()">Add Individual</button>
        </div>
      </div>
    </div>



  </div>
</div>

<!-- overlay message for same records -->
<div tabindex="-1" id="info-popup" class="overlay" [ngClass]="(dialogData.hideDOBError)?'hideDOBError':''">
  <div class="info-popup">
    <label class="child-info-text" tabindex="0" role="alert" aria-label="dialog">
      We have found an existing record in the system that matches those details, so we need verification before we can add this child to your account.
    Please contact your child's club or&nbsp;County FA to help you complete this process.</label>
    <button class="save-button error-btn" aria-label="ok" tabindex="0" (click)="dialogData.closeInfoPopup()">OK</button>
  </div>
</div>

<!-- template for day, month, year select controls-->
<ng-template #dateofbirth let-dobType let-control="control" let-displayType="displayType" let-data="data">
  <select aria-label="date" [formControl]="control" [id]="dobType" (click)="dialogData.onDateInput()" >
    <option [value]="">{{displayType}}</option>
    @for (d of data; track d; let i = $index) {
      <option [value]="(dobType==='month') ? i+1 : d">
        {{d}}
      </option>
    }
  </select>
</ng-template>
